/**
 *  추천 상품 후기 페이지 이름
 */
export const RECOMMEND_REVIEW_PAGE_NAME = {
  RECOMMEND_REVIEW_LIST: '추천 상품 후기 리스트',
  RECOMMEND_REVIEW_DETAIL: '추천 상품 후기 상세',
  RECOMMEND_REVIEW_COPY: '추천 상품 후기 복사',
  RECOMMEND_REVIEW_CREATE: '추천 상품 후기 등록',
};

/**
 *  추천 상품 후기 타입
 */
export const RECOMMEND_REVIEW_TYPE = {
  /**
   *  검색 화면 - 추천 후기
   */
  SEARCH_RECOMMEND: 0,
};

/**
 *  추천 상품 후기 타입 텍스트
 */
export const RECOMMEND_REVIEW_TYPE_TEXT = {
  [RECOMMEND_REVIEW_TYPE.SEARCH_RECOMMEND]: '검색 추천',
};

/**
 *  추천 상품 후기 타입 SELECT 리스트
 */
export const RECOMMEND_REVIEW_TYPE_SELECT_LIST = [
  {
    id: RECOMMEND_REVIEW_TYPE.SEARCH_RECOMMEND,
    name: RECOMMEND_REVIEW_TYPE_TEXT[RECOMMEND_REVIEW_TYPE.SEARCH_RECOMMEND],
  },
];

/**
 *  추천 상품 후기 메모 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_RECOMMEND_REVIEW_MEMO = 2000;

/**
 *  추천 상품 후기 아이템 최소 개수
 */
export const MINIMUM_NUMBER_OF_RECOMMEND_REVIEW_ITEM_COUNT = 3;

/**
 *  추천 상품 후기 아이템 최대 개수
 */
export const MAXIMUM_NUMBER_OF_RECOMMEND_REVIEW_ITEM_COUNT = 5;
